export var SubscriptionStatus;
(function (SubscriptionStatus) {
    // Stripe
    SubscriptionStatus["TRIALING"] = "trialing";
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELED"] = "canceled";
    SubscriptionStatus["INCOMPLETE"] = "incomplete";
    SubscriptionStatus["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    SubscriptionStatus["PAST_DUE"] = "past_due";
    SubscriptionStatus["UNPAID"] = "unpaid";
    // Internal
    SubscriptionStatus["INACTIVE"] = "inactive";
    SubscriptionStatus["NONE"] = "none";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export const allowedSubscriptionStatus = [
    SubscriptionStatus.TRIALING,
    SubscriptionStatus.ACTIVE,
];
//# sourceMappingURL=subscriptionStatus.js.map